import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedTimeSchedule: {},
    timeSchedules: [],
  }),

  mutations: {
    setSelectedTimeSchedule(state, timeSchedule) {
      Vue.set(state, "selectedTimeSchedule", timeSchedule);
    },
    setTimeSchedules(state, timeSchedules) {
      Vue.set(state, "timeSchedules", timeSchedules);
    },
    setDefaultTimeSchedule(state) {
      Vue.set(state, "selectedTimeSchedule", {});
      Vue.set(state, "timeSchedules", []);
    },
  },

  actions: {
    //TODO: load, update, create
    createTimeSchedule: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/time-schedule/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadTimeSchedules: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/time-schedule/entity").then((response) => {
        context.commit("setSelectedTimeSchedule", response.data);
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadPublishedTimeSchedules: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/time-schedule/entity/published").then((response) => {
        return response.data;
      });
    },

    loadSelectedTimeScheduleHistory: (context, timeSchedule) => {
      return axios.get(context.getters.getMcServiceUrl + "/time-schedule/history/" + timeSchedule.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteTimeSchedule: (context, timeSchedule) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/time-schedule/entity/" + timeSchedule.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          timeSchedule.intents = intents;
          timeSchedule.intentId = response.data.id;
          return timeSchedule;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftTimeSchedule: (context, timeSchedule) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/time-schedule/draft/" + timeSchedule.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishTimeSchedule: (context, timeSchedule) => {
      return axios.get(context.getters.getMcServiceUrl + "/time-schedule/publish/" + timeSchedule.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        //Fixme: intents type CREATE_STATION ise get isteği atılmalı.
        if (timeSchedule.intents[0].type === "DELETE_TIME_SCHEDULE") {
          let timeSchedules = context.getters.getSegments;
          timeSchedules.splice(timeSchedules.indexOf(timeSchedule), 1);
          context.commit("setTimeSchedules", timeSchedules);
        }
        return response.data;
      });
    },

    rejectTimeSchedule: (context, timeSchedule) => {
      return axios.get(context.getters.getMcServiceUrl + "/time-schedule/reject/" + timeSchedule.intentId).then((response) => {
        helper.recallOrRejectEntity(timeSchedule, "time_Schedule");
        return response.data;
      });
    },

    sendToApprovalTimeSchedules: (context, timeSchedule) => {
      return axios.get(context.getters.getMcServiceUrl + "/time-schedule/sendToApproval/" + timeSchedule.intentId).then((response) => {
        if (timeSchedule.intents[0].type === "CREATE_TIME_SCHEDULE") {
          timeSchedule.intents[0].status = "WAITING_APPROVAL";
        } else if (timeSchedule.intents[0].type === "UPDATE_TIME_SCHEDULE") {
          timeSchedule.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallTimeSchedule: (context, timeSchedule) => {
      return axios.get(context.getters.getMcServiceUrl + "/time-schedule/recall/" + timeSchedule.intentId).then((response) => {
        helper.recallOrRejectEntity(timeSchedule, "time_Schedule");
        return response.data;
      });
    },

    cancelTimeSchedule: (context, timeSchedule) => {
      return axios.get(context.getters.getMcServiceUrl + "/time-schedule/cancel/" + timeSchedule.intentId).then((response) => {
        return response.data;
      });
    },
  },

  getters: {
    getSelectedTimeSchedule: (state) => {
      return state.selectedTimeSchedule;
    },
    getTimeSchedules: (state) => {
      return state.timeSchedules;
    },
  },
};
